import { takeLatest, put } from 'redux-saga/effects'
import { createReducer, makeAction, makeKeys, urlWithPrefix } from './helper'
import { httpPost, httpPut, httpGet, httpDelete, responseIsSuccess } from 'core/restClient'
import { appLoading, appLoaded, toastError, toastSuccess } from './app'
import { bgVendorRequestPath, bgVendorRequestEditPath, homePath } from 'routes'

const createKeys = (key) => makeKeys(`BG_REQUEST_${key}`)

const GET_LIST = createKeys('GET_LIST')
const CREATE = createKeys('CREATE')
const UPLOAD_ATTACHMENTS = createKeys('UPLOAD_ATTACHMENTS')
const SUBMIT = createKeys('SUBMIT')
const GET_DETAIL = createKeys('GET_DETAIL')
const UPDATE = createKeys('UPDATE')
const DELETE = createKeys('DELETE')
const CANCEL = createKeys('CANCEL')
const ACTION = createKeys('ACTION')
const SAVE_RETURN_DATA = createKeys('SAVE_RETURN_DATA')
const GET_REF_BG_OPTIONS = createKeys('GET_REF_BG_OPTIONS')
const GET_WORKFLOW = createKeys('GET_WORKFLOW')
const GET_BG_RELATED = createKeys('GET_BG_RELATED')
const CLEAR_FROM_DATA = 'CLEAR_FROM_DATA'
const UPLOAD_BG_FORM = createKeys('UPLOAD_BG_FORM')
const GET_COMPANY_OPTIONS = createKeys('GET_COMPANY_OPTIONS')
const GET_VENDOR_OPTIONS = createKeys('GET_VENDOR_OPTIONS')
const GET_PRINT_FORM = createKeys('GET_PRINT_FORM')
const GET_LOAD_AMOUNT = createKeys('GET_LOAD_AMOUNT')
const GET_TOTAL_BG_AMOUNT = createKeys('GET_TOTAL_BG_AMOUNT')
const CLEAR_BG_REF = 'CLEAR_BG_REF'

export const getBGRequest = makeAction(GET_LIST.REQUEST, 'query')
export const createBGRequest = makeAction(CREATE.REQUEST, 'data', 'isSubmit', 'history')
export const uploadAttachments = makeAction(UPLOAD_ATTACHMENTS.REQUEST, 'id', 'data', 'isSubmit','history', 'actionKey', 'onSuccess')
export const submitBGRequest = makeAction(SUBMIT.REQUEST, 'id', 'history')
export const getBGRequestDetail = makeAction(GET_DETAIL.REQUEST, 'id')
export const updateBGRequest = makeAction(UPDATE.REQUEST, 'data', 'isSubmit', 'history', 'actionKey', 'onSuccess')
export const deleteBGRequest = makeAction(DELETE.REQUEST, 'id', 'history')
export const cancelBGRequest = makeAction(CANCEL.REQUEST, 'id', 'comment', 'history')
export const actionBGRequest = makeAction(ACTION.REQUEST, 'data', 'history', 'onSuccess')
export const getRefBGRequestOptions = makeAction(GET_REF_BG_OPTIONS.REQUEST)
export const getWorkflow = makeAction(GET_WORKFLOW.REQUEST, 'id')
export const getBgRelated = makeAction(GET_BG_RELATED.REQUEST, 'bgId', 'onSuccess')
export const clearFormData = makeAction(CLEAR_FROM_DATA)
export const saveReturnData = makeAction(SAVE_RETURN_DATA.REQUEST, 'data', 'onSuccess')
export const uploadBgForm = makeAction(UPLOAD_BG_FORM.REQUEST, 'id', 'data', 'onSuccess' )
export const getCompanyOptionsBGR = makeAction(GET_COMPANY_OPTIONS.REQUEST)
export const getVendorOptionsBGR = makeAction(GET_VENDOR_OPTIONS.REQUEST)
export const getPrintForm = makeAction(GET_PRINT_FORM.REQUEST, 'id')
export const getLoadAmount = makeAction(GET_LOAD_AMOUNT.REQUEST, 'vendorCode', 'companyCode', 'onSuccess')
export const getTotalActiveAmount = makeAction(GET_TOTAL_BG_AMOUNT.REQUEST, 'vendorCode', 'companyCode', 'onSuccess')
export const clearBgRef = makeAction(CLEAR_BG_REF)

const getBGRequestSuccess = makeAction(GET_LIST.SUCCESS, 'data')
const getBGRequestDetailSuccess = makeAction(GET_DETAIL.SUCCESS, 'data')
const getRefBGRequestOptionsSuccess = makeAction(GET_REF_BG_OPTIONS.SUCCESS, 'data')
const getWorkflowSuccess = makeAction(GET_WORKFLOW.SUCCESS, 'data')
const getCompanyOptionsSuccess = makeAction(GET_COMPANY_OPTIONS.SUCCESS, 'data')
const getVendorOptionsSuccess = makeAction(GET_VENDOR_OPTIONS.SUCCESS, 'data')
const getPrintFormSuccess = makeAction(GET_PRINT_FORM.SUCCESS, 'data')

const apiPath = path => path ? urlWithPrefix(`bankGuaranteeRequests/${path}`) : urlWithPrefix('bankGuaranteeRequests')
const multipartHeader = { 'Content-Type': 'multipart/form-data', }

function* getBankGuaranteesRequest(action) {
  const { query } = action.payload

  try {
    yield put(appLoading('Loading Bank Guarantee Data'))
    const response = yield httpGet(apiPath(), { ...query })
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      if (response.data) {
        yield put(getBGRequestSuccess(response.data))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Load Bank Guarantee Error!'))
    }
    yield put(getBGRequestSuccess([]))
    yield put(appLoaded())
  }
}

function* createBankGuaranteeRequest(action) {
  const { data, isSubmit, history } = action.payload

  try {
    yield put(appLoading('Create bank guarantee request.'))
    const response = yield httpPost(apiPath(), data)
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      const { id } = response.data
      var attachmentsData = {}
      if (data.BG04) attachmentsData.BG04 = data.BG04
      if (data.BG02) attachmentsData.BG02 = data.BG02

      if (Object.keys(attachmentsData).length) {
        yield put(uploadAttachments(id, attachmentsData, isSubmit, history))
      } else {
        if (isSubmit) {
          yield put(submitBGRequest(id, history))
        } else {
          yield put(toastSuccess('Create bank guarantee request success.'))
          history.push(bgVendorRequestPath)
        }
      }
    }
  } catch (e) {
    yield put(appLoaded())

    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Create bank guarantee error!'))
    }
  }
}

function* uploadAttachmentsRequest(action) {
  const { id, data, isSubmit, history, actionKey, onSuccess } = action.payload

  try {
    yield put(appLoading(`Upload attachments.`))
    const response = yield httpPost(apiPath(`${id}/attachments`), data, multipartHeader /*, config */)
    if (responseIsSuccess(response)) {
      if (response.data) {
        if (isSubmit) {
          yield put(submitBGRequest(id, history))
        } else {
          if (actionKey) {
            const submitData = { 
              id: data.id, 
              comment: data.comment, 
              attachment: data.commentAttachment, 
              sn: data.sn,
              action: actionKey
            }

            yield put(actionBGRequest(submitData, history))
          } else {
            yield put(toastSuccess('Save bank guarantee success.'))
            yield put(appLoaded())
            if (onSuccess) {
              onSuccess()
            }
            if (history) {
              history.push(bgVendorRequestPath)
            }
          }
        }
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(toastError('Upload attachments data fail.'))
  }
}

function* getBankGuaranteeDetailRequest(action) {
  const { id } = action.payload

  try {
    yield put(appLoading('Loading bank guarantee data'))
    const response = yield httpGet(apiPath(id))
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      if (response.data) {
        yield put(getBGRequestDetailSuccess(response.data))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Load bank guarantee data error!'))
    }
    yield put(appLoaded())
  }
}

function* updateBankGuaranteeRequest(action) {
  const { data, isSubmit, history, actionKey = '', onSuccess } = action.payload

  try {
    yield put(appLoading('Updating bank guarantee data.'))
    const response = yield httpPut(apiPath(data.id), data)
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      var attachmentsData = {}
      if (data.BG04) attachmentsData.BG04 = data.BG04
      if (data.BG02) attachmentsData.BG02 = data.BG02

      if (Object.keys(attachmentsData).length) {
        yield put(uploadAttachments(data.id, attachmentsData, isSubmit, history, actionKey, onSuccess))
      } else {
        if (isSubmit) {
          yield put(submitBGRequest(data.id, history))
        } else if (onSuccess) {
          onSuccess()
        } else {
          if (actionKey) {
            const submitData = { 
              id: data.id, 
              comment: data.comment, 
              attachment: data.commentAttachment, 
              sn: data.sn,
              action: actionKey
            }

            yield put(actionBGRequest(submitData, history))
          } else {
            yield put(toastSuccess('Update bank guarantee success.'))
            history.push(bgVendorRequestPath)
          }
        }
      }
    }
  } catch (e) {
    yield put(appLoaded())

    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Update bank guarantee error!'))
    }
  }
}

function* submitBankGuaranteeRequest(action) {
  const { id, history } = action.payload
  try {
    yield put(appLoading('Submit bank guarantee request.'))
    const response = yield httpPut(apiPath(`${id}/submit`))
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      if (response.data) {
        history.push(bgVendorRequestPath)
        yield put(toastSuccess('Submit bank guarantee request success.'))
      } else {
        yield put(toastError('Submit bank guarantee request fail.'))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    history.push(bgVendorRequestEditPath(id))
    yield put(toastError(e.data.message))
  }
}

function* deleteBankGuaranteeRequest(action) {
  const { id, history } = action.payload
  try {
    yield put(appLoading('Delete bank guarantee request data.'))
    const response = yield httpDelete(apiPath(`${id}`))
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      if (response.data) {
        yield put(toastSuccess('Delete bank guarantee request success.'))
        history.push(bgVendorRequestPath)
      } else {
        yield put(toastError('Delete bank guarantee request fail.'))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(toastError(e.data.message))
  }
}

function* cancelBankGuaranteeRequest(action) {
  const { id, comment, history } = action.payload
  try {
    yield put(appLoading('Cancel bank guarantee data.'))
    const response = yield httpPut(apiPath(`${id}/cancel`), { id, comment })
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      if (response.data) {
        yield put(toastSuccess('Cancel bank guarantee data success.'))
        history.push(bgVendorRequestPath)
      } else {
        yield put(toastError('Cancel bank guarantee data fail.'))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(toastError(e.data.message))
  }
}

function* getRefBankGuaranteeOptionsRequest(action) {
  try {
    const response = yield httpGet(apiPath('options/bgRef'))
    if (responseIsSuccess(response)) {
      if (response.data) {
        yield put(getRefBGRequestOptionsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getRefBGRequestOptionsSuccess([]))
  }
}

function* getWorkflowRequest(action) {
  const { id } = action.payload
  try {
    const response = yield httpGet(apiPath('workflowApproverViewMode'), { id })
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      if (response.data) {
        yield put(getWorkflowSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(getWorkflowSuccess([]))
  }
}

function* actionBankGuaranteeRequest(action) {
  const { data, history, onSuccess } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpPost(apiPath(`${data.docId}/action`), data, multipartHeader)
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      if (onSuccess) {
        onSuccess()
      }
      if (history.location.search.includes('h=true')) {
        history.push(homePath)
      } else {
        history.push(bgVendorRequestPath)
      }
      yield put(toastSuccess('Action bank guarantee success.'))
    }
  } catch (e) {
    yield put(toastError(e.data.message || 'Action bank guarantee fail.'))
    yield put(appLoaded())
  }
}

function* getBgRelatedRequest(action) {
  const { bgId, onSuccess } = action.payload
  try {
    yield put(appLoading('Loading bank guarantee related data'))
    const response = yield httpGet(apiPath(`${bgId}/related`))
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      if (response.data && onSuccess) {
        onSuccess(response.data)
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Load bank guarantee data error!'))
    }
    yield put(appLoaded())
  }
}

function* saveReturnDataRequest(action) {
  const { data, onSuccess } = action.payload
  try {
    yield put(appLoading('Save bank guarantee return data.'))
    const response = yield httpPut(apiPath(`${data.id}/returnData`), data, multipartHeader)
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      if (onSuccess) onSuccess()
    }
  } catch (e) {
    yield put(toastError(e.data.message || 'Save bank guarantee return data fail.'))
    yield put(appLoaded())
  }
}

function* uploadBgFormRequest(action) {
  const { id, data, onSuccess } = action.payload

  try {
    yield put(appLoading(`Uploading attachments.`))
    const response = yield httpPost(apiPath(`${id}/bgForm`), data, multipartHeader)
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      yield put(toastSuccess('Upload attachments data complete.'))
      if (onSuccess) {
        onSuccess()
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(toastError('Upload attachments data fail.'))
  }
}

function* getCompanyOptionsRequest(action) {
  try {
    const response = yield httpGet(apiPath('options/company'))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getCompanyOptionsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(getCompanyOptionsSuccess([]))
  }
}

function* getVendorOptionsRequest(action) {
  try {
    const response = yield httpGet(apiPath('options/vendor'))
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getVendorOptionsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    yield put(getVendorOptionsSuccess([]))
  }
}

function* getPrintFormRequest(action) {
  const { id } = action.payload

  try {
    yield put(appLoading('Loading bank guarantee data'))
    const response = yield httpGet(apiPath(`${id}/printForm`))
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      if (response.data) {
        yield put(getPrintFormSuccess(response.data))
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Load bank guarantee data error!'))
    }
    yield put(appLoaded())
  }
}

function* getLoadAmountRequest(action) {
  const { vendorCode, companyCode, onSuccess } = action.payload
  try {
    const response = yield httpGet(apiPath(`loadAmount/${vendorCode}/${companyCode}`))
    if (responseIsSuccess(response)) {
      if (response.data !== null && onSuccess) {
        onSuccess(response.data)
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    }
  }
}

function* getTotalActiveAmountRequest(action) {
  const { vendorCode, companyCode, onSuccess } = action.payload
  try {
    const response = yield httpGet(apiPath(`totalBgAmount/${vendorCode}/${companyCode}`))
    if (responseIsSuccess(response)) {
      if (response.data !== null && onSuccess) {
        onSuccess(response.data)
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    }
  }
}

export function* watchBGRequestSaga() {
  yield takeLatest(GET_LIST.REQUEST, getBankGuaranteesRequest)
  yield takeLatest(CREATE.REQUEST, createBankGuaranteeRequest)
  yield takeLatest(UPLOAD_ATTACHMENTS.REQUEST, uploadAttachmentsRequest)
  yield takeLatest(GET_DETAIL.REQUEST, getBankGuaranteeDetailRequest)
  yield takeLatest(UPDATE.REQUEST, updateBankGuaranteeRequest)
  yield takeLatest(SUBMIT.REQUEST, submitBankGuaranteeRequest)
  yield takeLatest(DELETE.REQUEST, deleteBankGuaranteeRequest)
  yield takeLatest(CANCEL.REQUEST, cancelBankGuaranteeRequest)
  yield takeLatest(GET_REF_BG_OPTIONS.REQUEST, getRefBankGuaranteeOptionsRequest)
  yield takeLatest(GET_WORKFLOW.REQUEST, getWorkflowRequest)
  yield takeLatest(ACTION.REQUEST, actionBankGuaranteeRequest)
  yield takeLatest(GET_BG_RELATED.REQUEST, getBgRelatedRequest)
  yield takeLatest(SAVE_RETURN_DATA.REQUEST, saveReturnDataRequest)
  yield takeLatest(UPLOAD_BG_FORM.REQUEST, uploadBgFormRequest)
  yield takeLatest(GET_COMPANY_OPTIONS.REQUEST, getCompanyOptionsRequest)
  yield takeLatest(GET_VENDOR_OPTIONS.REQUEST, getVendorOptionsRequest)
  yield takeLatest(GET_PRINT_FORM.REQUEST, getPrintFormRequest)
  yield takeLatest(GET_LOAD_AMOUNT.REQUEST, getLoadAmountRequest)
  yield takeLatest(GET_TOTAL_BG_AMOUNT.REQUEST, getTotalActiveAmountRequest)
}

const initial = {
  listBGRequest: { data: {}, loading: false },
  bgRequest: { data: {}, loading: false },
  bgRequestRefOptions: { data: [], loading: false, companyCode: '', vendorCode: '' },
  workflow: { data: [], loading: false },
  companyOptions: { data: [], loading: false },
  vendorOptions: { data: [], loading: false },
  printForm: { data: {}, loading: false },
  bgRefOptions: { data: [], loading: false },
}

export default createReducer(initial, state => ({
  [GET_LIST.REQUEST]: () => ({
    ...state,
    listBGRequest: { data: {}, loading: true }
  }),
  [GET_LIST.SUCCESS]: (data) => ({
    ...state,
    listBGRequest: { data: data.data, loading: false }
  }),
  [GET_LIST.FAILURE]: (data) => ({
    ...state,
    listBGRequest: { data: {}, loading: false }
  }),
  [GET_DETAIL.REQUEST]: () => ({
    ...state,
    bgRequest: { data: {}, loading: true }
  }),
  [GET_DETAIL.SUCCESS]: (data) => ({
    ...state,
    bgRequest: { data: data.data, loading: false }
  }),
  [GET_REF_BG_OPTIONS.REQUEST]: (data) => ({
    ...state,
    bgRefOptions: { data: [], loading: true }
  }),
  [GET_REF_BG_OPTIONS.SUCCESS]: (data) => ({
    ...state,
    bgRefOptions: { data: data.data, loading: false }
  }),
  [GET_WORKFLOW.REQUEST]: () => ({
    ...state,
    workflow: { data: [], loading: true }
  }),
  [GET_WORKFLOW.SUCCESS]: (data) => ({
    ...state,
    workflow: { data: data.data, loading: false }
  }),
  [CLEAR_FROM_DATA]: () => ({
    ...state,
    bankGuarantee: { data: {}, loading: false },
    workflow: { data: [], loading: false },
  }),
  [GET_COMPANY_OPTIONS.REQUEST]: () => ({
    ...state,
    companyOptions: { data: [], loading: true }
  }),
  [GET_COMPANY_OPTIONS.SUCCESS]: (data) => ({
    ...state,
    companyOptions: { data: data.data, loading: false }
  }),
  [GET_VENDOR_OPTIONS.REQUEST]: () => ({
    ...state,
    vendorOptions: { data: [], loading: true }
  }),
  [GET_VENDOR_OPTIONS.SUCCESS]: (data) => ({
    ...state,
    vendorOptions: { data: data.data, loading: false }
  }),
  [GET_PRINT_FORM.REQUEST]: () => ({
    ...state,
    printForm: { data: {}, loading: true }
  }),
  [GET_PRINT_FORM.SUCCESS]: (data) => ({
    ...state,
    printForm: { data: data.data, loading: false }
  }),
  [CLEAR_BG_REF]: () => ({
    ...state,
    bgRefOptions: { data: [], loading: false }
  }),
}))